"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_vodafone__store(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "397f1106-35d1-4760-8b8f-f9b133b69ed1",
    "data-name": "vodafone-store-hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cfb6895a-00d6-4497-99d9-fcff0db07c62",
    x1: 56.36,
    y1: 23.79,
    x2: 181.67,
    y2: 149.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "vodafone-store-hi"), /*#__PURE__*/React.createElement("g", {
    id: "ad05f70d-dae4-4cff-93bd-e5af2a04847f",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8f4e69c2-268e-44aa-bcc7-46d56a45e7b3",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fdec81ca-6606-4346-9940-9a6d77e03dc9",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f9652bd7-9bae-4fce-a38c-e2e9fdc58043",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148,172h4a16,16,0,0,0,16-16V72a16,16,0,0,0-16-16H40A16,16,0,0,0,24,72v84a16,16,0,0,0,16,16H148Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,172a16,16,0,0,0,16-16v-2a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.15,70,125,172h27.15a16,16,0,0,0,16-16V56h-144Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#cfb6895a-00d6-4497-99d9-fcff0db07c62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.45,56c0-.24-.07-.47-.12-.71l-4.68-22.53A16,16,0,0,0,155,20l-15.75,0v0l-28.79,0v0L81.63,20v0L52.84,20v0L37,20A16,16,0,0,0,21.4,32.77L16.72,55.26c-.05.25-.09.5-.13.74m0,0A15.84,15.84,0,1,0,48,58.62a16,16,0,0,0,32,0,16,16,0,0,0,32,0,16,16,0,0,0,32,0A15.85,15.85,0,1,0,175.45,56",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.45,56H16.6A15.84,15.84,0,1,0,48,58.62a16,16,0,0,0,32,0,16,16,0,0,0,32,0,16,16,0,0,0,32,0A15.85,15.85,0,1,0,175.45,56Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.11,57.92c0-.43-.06-.86-.07-1.3A16,16,0,0,1,24,70.32a15.63,15.63,0,0,1-7.55-12.6A15.55,15.55,0,0,0,32,74.5,16,16,0,0,0,48,58.62s0-.08,0-.12Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,57.53a16,16,0,0,1-31.9,0l0,1s0,.08,0,.12a16,16,0,0,0,32,0s0-.08,0-.12Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.95,69.77A16,16,0,0,1,144,56.62c0,.44,0,.87-.07,1.31l.07.58s0,.08,0,.12a16,16,0,0,0,24.94,13.15,15.74,15.74,0,0,0,6.69-14A15.57,15.57,0,0,1,168.95,69.77Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.07,57.4c0-.26,0-.52,0-.79A16,16,0,0,1,48.11,58L48,58.5s0,.08,0,.12a16,16,0,0,0,32,0s0-.08,0-.12Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.94,58A16,16,0,0,1,112,56.62c0,.26,0,.52,0,.79l0,1.1s0,.08,0,.12a16,16,0,0,0,32,0s0-.08,0-.12Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,105.8a25,25,0,1,0,25,25A25,25,0,0,0,96,105.8Zm12.23,31.71a13.09,13.09,0,0,1-3.58,4.34,13.43,13.43,0,0,1-12.07,2.35,14.28,14.28,0,0,1-8-6,15.24,15.24,0,0,1-1.81-4c0-.11-.06-.22-.09-.33a16.56,16.56,0,0,1-.46-2.47,17.51,17.51,0,0,1-.08-2.58c0-.09,0-.17,0-.26a19.7,19.7,0,0,1,.54-3.59,21.68,21.68,0,0,1,7-11.21,23.42,23.42,0,0,1,6.85-4c.69-.27,1.38-.5,2-.7.43-.13.86-.24,1.28-.34a25.33,25.33,0,0,1,3.17-.57,12.72,12.72,0,0,1,3.15,0,2.81,2.81,0,0,1,.51.12,10.3,10.3,0,0,0-8.15,10c0,.11,0,.23,0,.34a16.45,16.45,0,0,1,5.28,2,11.92,11.92,0,0,1,3.47,3.2l.2.29a11.82,11.82,0,0,1,1.51,3.2,14.33,14.33,0,0,1,.58,3.62c0,.16,0,.33,0,.49A13.39,13.39,0,0,1,108.23,137.51Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 35,
    width: 2,
    height: 104,
    transform: "translate(183 -9) rotate(90)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 88,
    width: 104,
    height: 84,
    opacity: 0.06
  }))))));
}

var _default = ic_vodafone__store;
exports.default = _default;